import { c as _c } from "react/compiler-runtime";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { useAppSelector } from "@store/store-helper";
import { getTeamByIdSelector } from "@store/teams/teams-selector";
import { grey, ListItemText, TeamIcon } from "@flat-ui";
/** List item in bulk action dialog for teams */
export function TeamListContent(t0) {
  const $ = _c(8);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.id) {
    t1 = getTeamByIdSelector(item.id);
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const team = useAppSelector(t1);
  if (team === undefined) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SphereAvatar icon={<TeamIcon />} backgroundColor={grey[700]} shouldHideWhiteRim={true} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== team.name) {
    t3 = <var>{team.name}</var>;
    $[3] = team.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${team.memberCount} members`;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <>{t2}<ListItemText primary={t3} secondary={t4} /></>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}